export default __webpack_public_path__ + "static/media/loader.43b88d0d.gif";